import { Dialog, Grow } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import "./DataModal.scss";
import { authContext } from "../Context/Authentication/authContext";
import { baseURL } from "../config";
import axios from "axios";
import { generateMonthCount } from "../util";
import moment from "moment";
import { Bars } from "react-loader-spinner";
import Chart from "./Chart";
import { TransitionProps } from "@mui/material/transitions";
import bg2 from "../assets/1.jpg";
import bg4 from "../assets/ss1.png";
import bg6 from "../assets/chatBg_6.png";
import bg7 from "../assets/modestoBg1.png";
import page4bg from "../assets/reportBg3.jpeg";
import video from "../assets/reportVideo.mp4";
import modestoBg1 from "../assets/modestoBg10.png";
import modestoBg2 from "../assets/modestoBg11.png";
import modestoBg3 from "../assets/modestoBg3.png";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Grow ref={ref} {...props} style={{ transitionDuration: "1000ms" }} />;
});

const DataModal = ({ data, open, handleClose }: any) => {
  const { state }: any = useContext(authContext);

  const [chartData, setChartData]: any = useState(null);
  const [hsChartData, setHsChartData]: any = useState(null);

  const years = [49, 98];
  const cityData = ["Modesto"];
  const stateName = "California";
  const value = "Absolute";
  // const selectedType = 'predictedMetrics'

  useEffect(() => {
    setChartData(null);
    getPPSF();
    getHomeSales();
  }, []);

  const getHomeSales = async () => {
    const start = years[0];
    const end = years[1];
    try {
      const city = JSON.stringify(state.filters.city)
      .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
      .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getHomeSales?state=${stateName}&city=${city}&startYear=${start}&endYear=${end}&flag=${value.toLowerCase()}`
      );
      const data = generateHomeSalesChartData(response.data?.cube);
      setHsChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getPPSF = async () => {
    const start = years[0];
    const end = years[1];
    try {
      const city = JSON.stringify(state.filters.city)
      .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
      .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getPPSF?state=${stateName}&city=${city}&startYear=${start}&endYear=${end}&flag=${value.toLowerCase()}`
      );
      const data = generateChartData(response.data?.cube);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const generateChartData = (apiData: any) => {
    try {
      const start = years[0];
      const end = years[1];
      const totalMonths = generateMonthCount(start, end);
      const data: any = [];
      for (let i = 0; i < totalMonths; i++) {
        let value: any = {};
        for (let j = 0; j < cityData?.length; j++) {
          if (apiData[cityData[j]]?.length) {
            value = {
              ...value,
              date: moment(apiData[cityData[j]][i]?.date).format("YYYY-MM-DD"),
              [`value${j + 1}`]: apiData[cityData[j]][i]?.ppsf,
            };
          } else {
            continue;
          }
        }
        Object.keys(value)?.length > 0 && data.push(value);
      }
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const generateHomeSalesChartData = (apiData: any) => {
    try {
      const start = years[0];
      const end = years[1];
      const totalMonths = generateMonthCount(start, end);
      const data: any = [];
      for (let i = 0; i < totalMonths; i++) {
        let value: any = {};
        for (let j = 0; j < cityData?.length; j++) {
          if (apiData[cityData[j]]?.length) {
            value = {
              ...value,
              date: moment(apiData[cityData[j]][i]?.date).format("YYYY-MM-DD"),
              [`value${j + 1}`]: apiData[cityData[j]][i]?.homeSales,
            };
          } else {
            continue;
          }
        }
        Object.keys(value)?.length > 0 && data.push(value);
      }
      return data;
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Dialog
      open={open}
      fullScreen
      className="dataModal-main"
      TransitionComponent={Transition}
    >
      <div
        style={{
          position: "absolute",
          right: "3%",
          top: "0%",
          zIndex: 999,
          backgroundColor: "#000",
          padding: "0.2rem 1rem",
          fontWeight: "bold",
          cursor: "pointer",
        }}
        onClick={handleClose}
      >
        Close
      </div>
      {/* <IconButton
        style={{ position: "absolute", right: "1%", top: "1%", zIndex: 999 }}
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton> */}
      <div
        style={{
          width: "100%",
          position: "absolute",
          height: "100%",
          display: "block",
        }}
      >
        {data !== "1_4" &&
          data !== "1_5" &&
          data !== "2_3" &&
          data !== "3_1" &&
          data !== "3_4" &&
          data !== "3_5" && (
            <div
              className="dataModal-main__container"
              style={{
                textAlign: "center",
                paddingBottom:
                  data !== "1_2" && data !== "2_1" ? "0rem" : "3rem",
                height: data !== "3_3" && data !== "1_3" ? "24rem" : "27rem",
              }}
            >
              {data === "1_3" && (
                <img src={bg7} style={{ height: "100%", width: "100%" }}></img>
              )}
              {data === "3_2" && (
                <img src={bg4} style={{ height: "100%", width: "100%" }}></img>
              )}
              {data === "3_3" && (
                <img
                  src={modestoBg3}
                  style={{ height: "100%", width: "62%" }}
                ></img>
              )}
              {/* {data === "2_1" && (
                <img
                  src={page4bg}
                  style={{ height: "100%", width: "100%" }}
                ></img>
              )} */}
              {data === "2_2" && (
                // <img src={bg2} style={{ height: "100%", width: "100%" }}></img>
                <video
                  width="100%"
                  height="100%"
                  controls={false}
                  autoPlay={true}
                  muted
                  loop
                >
                  <source src={video} type="video/mp4" />
                </video>
              )}
              {data === "2_4" && (
                <img src={bg6} style={{ height: "100%", width: "100%" }}></img>
              )}
              {data === "1_1" && (
                <img
                  src={modestoBg1}
                  style={{ height: "100%", width: "100%" }}
                ></img>
                // <video
                //   width="100%"
                //   height="100%"
                //   controls={false}
                //   autoPlay={true}
                //   muted
                //   loop
                // >
                //   <source src={video} type="video/mp4" />
                // </video>
              )}
              {data === "1_2" &&
                (chartData === null ? (
                  <div className="dataModal-main__chartContainer__isLoading">
                    No Data available! : (
                    <Bars
                      height="400"
                      ariaLabel="bars-loading"
                      wrapperClass="tab-spinner-progress-bar"
                      visible={true}
                    />
                    )
                  </div>
                ) : chartData?.length ? (
                  <Chart
                    chartData={chartData}
                    title={"PPSFT $"}
                    city={cityData}
                    zipcode={state.filters.zipcode}
                    showInterval={state.filters.showInterval}
                  />
                ) : (
                  <div className="dataModal-main__chartContainer__noData">
                    No Data Available
                  </div>
                ))}
              {data === "2_1" &&
                (chartData === null ? (
                  <div className="dataModal-main__chartContainer__isLoading">
                    No Data available! : (
                    <Bars
                      height="400"
                      ariaLabel="bars-loading"
                      wrapperClass="tab-spinner-progress-bar"
                      visible={true}
                    />
                    )
                  </div>
                ) : chartData?.length ? (
                  <Chart
                    chartData={hsChartData}
                    title={"Home sales"}
                    city={cityData}
                    zipcode={state.filters.zipcode}
                    showInterval={state.filters.showInterval}
                  />
                ) : (
                  <div className="dataModal-main__chartContainer__noData">
                    No Data Available
                  </div>
                ))}
            </div>
          )}
        <div
          style={{
            // display: "flex",
            // flexDirection: "column",
            // flex: 1,
            // width: "100%",
            padding: "3rem",
          }}
        >
          {data === "1_1" && (
            <>
              <h3 className="dataModal-main__head">
                Geography Analyzed: Modesto, CA{" "}
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                Modesto is the largest city and the county seat of Stanislaus
                County. Modesto is situated about 92 miles east of San
                Francisco, 68 miles south of the state capital of Sacramento,
                and 66 miles west of Yosemite National Park. It is the 18th
                largest city in California with a population of about 250K.
                Modesto is a major center for agriculture, due to the fertile
                farmland that surrounds the city. It's known for its production
                of milk, almonds, chickens, walnuts, and corn. Modesto has a
                rich and diverse cultural scene for a city of its size, which
                includes the Gallo Center for the Arts, the Modesto Nuts minor
                league baseball team (a Colorado Rockies affiliate), and the
                annual Modesto Certified Farmer's Market. The city's climate is
                a Mediterranean climate, characterized by mild winters with
                moderate rainfall and hot, dry summers. One of the city's more
                notable characteristics is its motto: "Water Wealth Contentment
                Health," which is noted as one of the world's unique non-
                commercial city mottos.
              </p>
            </>
          )}
          {data === "1_2" && (
            <>
              <h3 className="dataModal-main__head">
                Prices and Demand
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                The housing market in Modesto is highly competitive. In April
                2023, there was a 2.2% decrease in Modesto home prices compared
                to the previous year, with homes selling at a median price of
                $440K. On average, homes in Modesto were on the market for 9
                days, slightly longer than the 8 days observed last year. Many
                homes receive multiple offers, some of which have waived
                contingencies. Typically, homes sell close to their listed price
                and go pending within approximately 13 days. In cases where the
                demand is particularly high, hot homes can sell for
                approximately 2% above the list price and go pending in about 5
                days.
              </p>
            </>
          )}
          {data === "1_3" && (
            <>
              <h3 className="dataModal-main__head">
                Vulnerability
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                During the last 12 months the real estate prices in Stanislaus,
                Modesto City increased, looking at the past 12 months. According
                to our Predictions of the Modesto real estate market, home
                values will decrease in the next 12 months. Median home values
                increased by 1.7% to 303673 USD, between May 2022 and May 2023
                The average annual profit of property investment was:
                <div style={{ margin: "1rem 0" }}>
                  <div>• 5.6% in 2018</div>
                  <div>• 3.7% in 2019</div>
                  <div>• -4.5% in 2020</div>
                  <div>• 0.3% in 2021</div>
                  <div>• 2.3% in 2022</div>
                </div>
                Based on our Predictions the sales prices will increase by 18%
                in the next 10 years. Over the last 12 months, the value of
                homes in Modesto City fluctuated: increasing 10 times and
                decreasing 2 times.
              </p>
            </>
          )}
          {data === "1_4" && (
            <>
              <h3 className="dataModal-main__head">
                Industries{" "}
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                <ul>
                  <li>
                    From 2019 to 2020, employment in Modesto, CA grew at a rate
                    of 1.26%, from 228k employees to 231k employees.{" "}
                  </li>
                  <li>
                    The most common employment sectors for those who live in
                    Modesto, CA, are Health Care & Social Assistance (30,367
                    people), Retail Trade (28,098 people), and Manufacturing
                    (27,461 people). This chart shows the share breakdown of the
                    primary industries for residents of Modesto, CA, though some
                    of these residents may live in Modesto, CA and work
                    somewhere else. Census data is tagged to a residential
                    address, not a work address.
                  </li>
                </ul>
              </p>
            </>
          )}
          {data === "1_5" && (
            <>
              <h3 className="dataModal-main__head">
                Occupation
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                Over the past few years. employment in Modesto, CA grew at a
                rate of 1.26%, from 228k employees to 231k employees.
                {/* </li>
                      <li> */}
                <div>
                  The most common job groups, by number of people living in
                  Modesto, CA, are Office & Administrative Support Occupations
                  (25,050 people), Sales & Related Occupations (23,134 people),
                  and Management Occupations (18,734 people).
                </div>
                Modesto's proximity to silicon valley and relative housing
                prices make it a destination for the employees to live in
                Modesto and work in the valley. This trend is expected to
                increase in the coming years.
              </p>
            </>
          )}
          {data === "2_1" && (
            <>
              <h3 className="dataModal-main__head">
                Where would we invest a $1000 for max ROI
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                Consectetur locavore brooklyn dreamcatcher, aesthetic anim dolor
                put a bird on it semiotics godard pork belly forage. VHS veniam
                aliqua thundercats dolore keffiyeh, direct trade authentic PBR
                eiusmod. Dolore veniam fanny pack, proident iphone mixtape irure
                sed. Lo-fi leggings stumptown cardigan etsy, pitchfork echo park
                terry richardson next level labore proident. Messenger bag
                cillum squid scenester, before they sold out dolor nostrud ad
                bicycle rights. Ut ex bicycle rights, wes anderson thundercats
                duis synth gluten-free hoodie twee. Four loko artisan viral,
                letterpress dreamcatcher twee yr cray vegan enim photo booth 3
                wolf moon. Id veniam mustache squid, cliche terry richardson
                organic quis dreamcatcher skateboard. Chambray before they sold
                out yr, iphone street art ut locavore squid placeat you probably
                haven't heard of them small batch. Cred proident occaecat wolf,
                fixie letterpress est biodiesel kogi gentrify. Artisan +1 culpa,
                bicycle rights trust fund direct trade consectetur gentrify
                synth pariatur twee delectus consequat wayfarers deserunt.
                Helvetica ex godard selvage, sriracha echo park ut portland
                forage cardigan. Retro readymade williamsburg cliche laboris
                pinterest. Mollit aliqua direct trade, tumblr vegan lo-fi
                shoreditch semiotics sed 8-bit. Incididunt keffiyeh PBR cray,
                assumenda yr butcher nisi. Mustache brunch kogi, farm-to-table
                small batch odio fugiat consequat fap esse quinoa. Iphone banh
                mi brunch jean shorts sartorial, letterpress culpa direct trade
                master cleanse banksy fap whatever quinoa biodiesel. Portland
                eiusmod minim nihil Austin, sartorial aesthetic occupy tofu
                sriracha pitchfork seitan.
              </p>
            </>
          )}
          {data === "2_2" && (
            <>
              {" "}
              <h3 className="dataModal-main__head">
                Highways & Traffic
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                Ethical 3 wolf moon sartorial nihil consequat twee, officia banh
                mi scenester carles vero thundercats. Keffiyeh mlkshk cliche
                craft beer, sartorial bespoke flexitarian helvetica consequat.
                Echo park organic nihil nostrud brooklyn scenester, delectus
                bushwick est narwhal sriracha. Chambray terry richardson direct
                trade, tumblr keffiyeh semiotics minim post-ironic. Sapiente
                nostrud banksy in nisi, lo-fi kale chips polaroid retro. 8-bit
                you probably haven't heard of them bespoke cred portland trust
                fund yr dolore sed. Art party quis street art american apparel
                lomo. Helvetica ex godard selvage, sriracha echo park ut
                portland forage cardigan. Retro readymade williamsburg cliche
                laboris pinterest. Mollit aliqua direct trade, tumblr vegan
                lo-fi shoreditch semiotics sed 8-bit. Incididunt keffiyeh PBR
                cray, assumenda yr butcher nisi. Mustache brunch kogi,
                farm-to-table small batch odio fugiat consequat fap esse quinoa.
                Iphone banh mi brunch jean shorts sartorial, letterpress culpa
                direct trade master cleanse banksy fap whatever quinoa
                biodiesel. Portland eiusmod minim nihil Austin, sartorial
                aesthetic occupy tofu sriracha pitchfork seitan.
              </p>
            </>
          )}
          {data === "2_3" && (
            <>
              <h3 className="dataModal-main__head">
                What-If Analysis Summary{" "}
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                Salvia +1 pork belly cosby sweater, lo-fi wolf tattooed VHS.
                Before they sold out dolore cray flexitarian et VHS +1 trust
                fund. Typewriter squid fap aute wolf 3 wolf moon, vice cillum
                street art. Austin organic gluten-free, ex cosby sweater odio
                squid. Iphone high life sriracha, +1 cupidatat assumenda
                shoreditch exercitation wayfarers. Aesthetic selvage nesciunt
                ennui. Nisi anim single-origin coffee, ullamco bushwick delectus
                fanny pack marfa tumblr cliche. Helvetica ex godard selvage,
                sriracha echo park ut portland forage cardigan. Retro readymade
                williamsburg cliche laboris pinterest. Mollit aliqua direct
                trade, tumblr vegan lo-fi shoreditch semiotics sed 8-bit.
                Incididunt keffiyeh PBR cray, assumenda yr butcher nisi.
                Mustache brunch kogi, farm-to-table small batch odio fugiat
                consequat fap esse quinoa. Iphone banh mi brunch jean shorts
                sartorial, letterpress culpa direct trade master cleanse banksy
                fap whatever quinoa biodiesel. Portland eiusmod minim nihil
                Austin, sartorial aesthetic occupy tofu sriracha pitchfork
                seitan.
              </p>
            </>
          )}
          {data === "2_4" && (
            <>
              <h3 className="dataModal-main__head">
                Secondary Modifiers
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                Consectetur locavore brooklyn dreamcatcher, aesthetic anim dolor
                put a bird on it semiotics godard pork belly forage. VHS veniam
                aliqua thundercats dolore keffiyeh, direct trade authentic PBR
                eiusmod. Dolore veniam fanny pack, proident iphone mixtape irure
                sed. Lo-fi leggings stumptown cardigan etsy, pitchfork echo park
                terry richardson next level labore proident. Messenger bag
                cillum squid scenester, before they sold out dolor nostrud ad
                bicycle rights. Ut ex bicycle rights, wes anderson thundercats
                duis synth gluten-free hoodie twee. Four loko artisan viral,
                letterpress dreamcatcher twee yr cray vegan enim photo booth 3
                wolf moon. Semiotics mlkshk anim sustainable butcher tempor.
                Odio single-origin coffee raw denim consequat mcsweeney's retro
                bespoke. Vero voluptate minim, letterpress accusamus twee
                farm-to-table pariatur cray. Helvetica ex godard selvage,
                sriracha echo park ut portland forage cardigan. Retro readymade
                williamsburg cliche laboris pinterest. Mollit aliqua direct
                trade, tumblr vegan lo-fi shoreditch semiotics sed 8-bit.
                Incididunt keffiyeh PBR cray, assumenda yr butcher nisi.
                Mustache brunch kogi, farm-to-table small batch odio fugiat
                consequat fap esse quinoa. Iphone banh mi brunch jean shorts
                sartorial, letterpress culpa direct trade master cleanse banksy
                fap whatever quinoa biodiesel. Portland eiusmod minim nihil
                Austin, sartorial aesthetic occupy tofu sriracha pitchfork
                seitan.
              </p>
            </>
          )}
          {data === "3_1" && (
            <>
              <h3 className="dataModal-main__head">
                Vulnerability Summary{" "}
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                Accusamus yr gluten-free id. Ennui occupy scenester polaroid,
                incididunt VHS minim sustainable skateboard aute cillum retro.
                Odd future gluten-free excepteur retro, biodiesel jean shorts
                minim nisi. Mlkshk hoodie next level pop-up 8-bit. Butcher
                scenester aliqua, tumblr nisi mcsweeney's PBR pork belly bespoke
                keytar cillum laboris swag pitchfork. Fugiat et eu american
                apparel truffaut brooklyn minim. Incididunt quis pickled,
                chillwave +1 odio dolore freegan est pop-up before they sold out
                twee cliche echo park ut. In high life swag tofu ethnic 8-bit,
                seitan pinterest DIY lomo post-ironic. Helvetica ex godard
                selvage, sriracha echo park ut portland forage cardigan. Retro
                readymade williamsburg cliche laboris pinterest. Mollit aliqua
                direct trade, tumblr vegan lo-fi shoreditch semiotics sed 8-bit.
                Incididunt keffiyeh PBR cray, assumenda yr butcher nisi.
                Mustache brunch kogi, farm-to-table small batch odio fugiat
                consequat fap esse quinoa. Iphone banh mi brunch jean shorts
                sartorial, letterpress culpa direct trade master cleanse banksy
                fap whatever quinoa biodiesel. Portland eiusmod minim nihil
                Austin, sartorial aesthetic occupy tofu sriracha pitchfork
                seitan.
              </p>
            </>
          )}
          {data === "3_2" && (
            <>
              <h3 className="dataModal-main__head">
                Data Quality Analysis
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                Wes anderson trust fund organic pour-over, aute authentic high
                life fanny pack enim. Ethnic mumblecore salvia, letterpress
                minim velit fugiat sartorial beard mixtape vice ad.
                Farm-to-table aute cred cosby sweater sed, dolore pork belly
                pinterest keytar 3 wolf moon mustache. Vice thundercats
                pour-over, lo-fi echo park accusamus ullamco adipisicing selvage
                street art you probably haven't heard of them etsy. Readymade
                bushwick mumblecore whatever aesthetic, do nesciunt direct trade
                proident culpa. Vegan you probably haven't heard of them hoodie
                adipisicing qui, voluptate Austin stumptown photo booth sed.
                Mixtape excepteur locavore eu, labore sustainable nisi tofu
                narwhal fanny pack VHS nulla aliqua. Beard velit street art aute
                sartorial. Sapiente pitchfork polaroid, fugiat ea DIY
                williamsburg forage officia sint occaecat. Gentrify exercitation
                cray marfa, blog biodiesel readymade aliquip beard placeat raw
                denim stumptown. Austin photo booth accusamus et semiotics.
                Messenger bag ethical direct trade ullamco jean shorts. Selvage
                authentic seitan direct trade delectus butcher, mollit occupy
                cillum photo booth banksy proident gentrify commodo vice. Retro
                qui cray whatever. Helvetica ex godard selvage, sriracha echo
                park ut portland forage cardigan. Retro readymade williamsburg
                cliche laboris pinterest. Mollit aliqua direct trade, tumblr
                vegan lo-fi shoreditch semiotics sed 8-bit. Incididunt keffiyeh
                PBR cray, assumenda yr butcher nisi. Mustache brunch kogi,
                farm-to-table small batch odio fugiat consequat fap esse quinoa.
                Iphone banh mi brunch jean shorts sartorial, letterpress culpa
                direct trade master cleanse banksy fap whatever quinoa
                biodiesel. Portland eiusmod minim nihil Austin, sartorial
                aesthetic occupy tofu sriracha pitchfork seitan.
              </p>
            </>
          )}
          {data === "3_3" && (
            <>
              <h3 className="dataModal-main__head">
                Predicted Traffic Patterns
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                This region is expected to see tremendous vehicular traffic
                growth over the next 2-4 years. This is because of the growing
                neighbourhoods and projected commute patterns.The county has
                invested in couple of highways development project. While that
                is helpful in easing the congestion it will also increase the
                vehicular traffic. Mcsweeney's pitchfork chambray tattooed four
                loko, commodo nesciunt lo-fi dreamcatcher mixtape eu occaecat
                vinyl cupidatat. Delectus selvage gentrify, commodo fingerstache
                jean shorts sriracha you probably haven't heard of them
                aesthetic. Bespoke nulla eiusmod deserunt, qui 8-bit +1 high
                life proident dolor small batch accusamus laborum ethical. In
                high life swag tofu ethnic 8-bit, seitan pinterest DIY lomo
                post-ironic. American apparel fingerstache portland, lomo
                thundercats small batch velit quis letterpress. Dolore iphone
                accusamus pitchfork authentic. Qui narwhal voluptate, street art
                keffiyeh non laborum. Helvetica ex godard selvage, sriracha echo
                park ut portland forage cardigan. Retro readymade williamsburg
                cliche laboris pinterest. Mollit aliqua direct trade, tumblr
                vegan lo-fi shoreditch semiotics sed 8-bit. Incididunt keffiyeh
                PBR cray, assumenda yr butcher nisi. Mustache brunch kogi,
                farm-to-table small batch odio fugiat consequat fap esse quinoa.
                Iphone banh mi brunch jean shorts sartorial, letterpress culpa
                direct trade master cleanse banksy fap whatever quinoa
                biodiesel. Portland eiusmod minim nihil Austin, sartorial
                aesthetic occupy tofu sriracha pitchfork seitan.
              </p>
            </>
          )}
          {data === "3_4" && (
            <>
              {" "}
              <h3 className="dataModal-main__head">
                Secondary Modifiers
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                Authentic put a bird on it mustache magna. Terry richardson
                dolor vero, magna odio synth letterpress umami brunch vice craft
                beer Austin. Velit mcsweeney's consequat wes anderson. Yr eu
                minim id. Pinterest odio keytar, irony bushwick pickled delectus
                placeat 3 wolf moon trust fund. Small batch mixtape carles
                chambray aute pop-up reprehenderit, portland magna skateboard
                vero dreamcatcher. Id artisan twee tempor excepteur pitchfork.
                Helvetica ex godard selvage, sriracha echo park ut portland
                forage cardigan. Retro readymade williamsburg cliche laboris
                pinterest. Mollit aliqua direct trade, tumblr vegan lo-fi
                shoreditch semiotics sed 8-bit. Incididunt keffiyeh PBR cray,
                assumenda yr butcher nisi. Mustache brunch kogi, farm-to-table
                small batch odio fugiat consequat fap esse quinoa. Iphone banh
                mi brunch jean shorts sartorial, letterpress culpa direct trade
                master cleanse banksy fap whatever quinoa biodiesel. Portland
                eiusmod minim nihil Austin, sartorial aesthetic occupy tofu
                sriracha pitchfork seitan.
              </p>
            </>
          )}
          {data === "3_5" && (
            <>
              {" "}
              <h3 className="dataModal-main__head">
                What-If Scenario Analysis Summary
                <span className="dataModal-main__head__span">
                  Analyzed on {moment().format("MMM DD, YYYY")}
                </span>
              </h3>
              <p className="dataModal-main__text">
                Nisi anim raw denim, occupy seitan magna selvage pork belly
                leggings gluten-free. Street art consequat aliquip, echo park
                helvetica enim pariatur fanny pack aesthetic et laboris pickled
                jean shorts ethical. Austin pop-up next level esse, retro quinoa
                locavore mollit etsy elit nesciunt quis salvia beard. Quis magna
                consequat selvage, ullamco commodo exercitation. VHS polaroid
                fugiat quis gastropub, cosby sweater aliquip aesthetic velit
                jean shorts swag. Put a bird on it etsy pork belly synth nisi,
                pitchfork wes anderson semiotics cliche ea. Cliche officia cosby
                sweater ullamco, quis stumptown est blog vinyl pork belly.
                Helvetica ex godard selvage, sriracha echo park ut portland
                forage cardigan. Retro readymade williamsburg cliche laboris
                pinterest. Mollit aliqua direct trade, tumblr vegan lo-fi
                shoreditch semiotics sed 8-bit. Incididunt keffiyeh PBR cray,
                assumenda yr butcher nisi. Mustache brunch kogi, farm-to-table
                small batch odio fugiat consequat fap esse quinoa. Iphone banh
                mi brunch jean shorts sartorial, letterpress culpa direct trade
                master cleanse banksy fap whatever quinoa biodiesel. Portland
                eiusmod minim nihil Austin, sartorial aesthetic occupy tofu
                sriracha pitchfork seitan.
              </p>
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default DataModal;
